import React from 'react';
import { useMarketingScripts } from '@/hooks/useMarketingScripts';
import { ConsentBanner } from './ConsentBanner';

interface MarketingProviderProps {
  children: React.ReactNode;
}

export const MarketingProvider: React.FC<MarketingProviderProps> = ({ children }) => {
  const { settings, consentState } = useMarketingScripts();

  return (
    <>
      {children}
      {settings && (
        <ConsentBanner 
          settings={{
            consent_required: settings.consent_required,
            consent_message: settings.consent_message
          }}
        />
      )}
    </>
  );
};






